// Design + AI portfolio content for the homepage sub-accordions.
// AI/Website-App case studies mirror /public/portfolio-design/index.html (final xlsx copy, verbatim).
// Visual/Graphic, Animation, Handmade & Glimpses data extracted from the legacy portfolio bundle.

export const AI_CASE_GROUPS = {
  "Images": [
    {
      "title": "Surana High Tech",
      "outputs": [
        {
          "type": "gallery",
          "src": [
            "/portfolio-design/assets/ai-images/surana/227.webp",
            "/portfolio-design/assets/ai-images/surana/228.webp",
            "/portfolio-design/assets/ai-images/surana/229.webp",
            "/portfolio-design/assets/ai-images/surana/230.webp",
            "/portfolio-design/assets/ai-images/surana/233.webp",
            "/portfolio-design/assets/ai-images/surana/234.webp",
            "/portfolio-design/assets/ai-images/surana/235.webp",
            "/portfolio-design/assets/ai-images/surana/237.webp",
            "/portfolio-design/assets/ai-images/surana/243.webp",
            "/portfolio-design/assets/ai-images/surana/249.webp",
            "/portfolio-design/assets/ai-images/surana/250.webp",
            "/portfolio-design/assets/ai-images/surana/suraasa.webp"
          ]
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "The need was to continuously improve the quality of the posts and also build the concept and high-quality designs in the optimum / fast time duration."
        },
        {
          "label": "What I Did",
          "text": "Apart from using conventional powerful tools like Canva and Photoshop, I started building the concept and then ran it across AI for building the copy. I then built the prompt to generate a design concept that matches the brand guide of the institution and trained the AI in such a way that it also helps to build further concepts aligned to what is expected in the fastest time possible."
        },
        {
          "label": "Impact",
          "text": "The conventional ways of designing would consume comparatively more time and also the revision cycles would add up to the additional time but here it brought down the time of delivery to 1/10th."
        }
      ]
    },
    {
      "title": "Betta Choc",
      "outputs": [
        {
          "type": "gallery",
          "src": [
            "/portfolio-design/assets/ai-images/betta/low-res-product1.webp",
            "/portfolio-design/assets/ai-images/betta/low-res-powder1.webp",
            "/portfolio-design/assets/ai-images/betta/low-res-powder2.webp"
          ]
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Upcoming powerful UK-based sustainable food brand required end-to-end fresh designs which would be simple, elegant, and yet appealing to the target audience."
        },
        {
          "label": "What I Did",
          "text": "A combination of sketched concepts and then building a detailed brief using AI, and then visualizing how the product looks for the pilot phase, and then creating the actual product designs for manufacturing. The end-to-end design cycle was handled."
        },
        {
          "label": "Impact",
          "text": "A satisfying output as acknowledged by the owners that they were very happy with the way it was conceptualized and brought to life and also they were happy with the way it was received by the end users."
        }
      ]
    }
  ],
  "Videos": [
    {
      "title": "Surana Schools Story",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/surana-story.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "The Founders' story, which was not known to everybody, had to be conveyed with the right emotions."
        },
        {
          "label": "What I Did",
          "text": "AI-enabled production pipeline helped me convey the same in the optimum quality and time possible."
        },
        {
          "label": "Impact",
          "text": "This was very well received by the institution and the entire parent and student community. They got to know about the founder and the history of the school in the best storytelling format possible."
        }
      ]
    },
    {
      "title": "Jelly bean",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/jellybean.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "This is a self-initiated project where the end-to-end production was done using AI."
        },
        {
          "label": "What I Did",
          "text": "For a complete production, there were always so many dependencies on people with different skills. Here the script, the music, voice animations, everything was done using AI. The concept was mine, built for using AI, and then everything was put together again manually using Adobe Creative Suite."
        },
        {
          "label": "Impact",
          "text": "This opened up the doors to the possibilities of what can be done for creative, educational, and entertaining content for the kids. There is a great scope for building better quality content for kids' education and this opened up the possibilities."
        }
      ]
    },
    {
      "title": "Dial50",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/dial50.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "When a new concept comes in, especially in the tech space, conveying it to the key stakeholders becomes challenging."
        },
        {
          "label": "What I Did",
          "text": "Built a video which conveys the entire concept using AI, which otherwise would be very difficult to do with the traditional video shooting production process."
        },
        {
          "label": "Impact",
          "text": "A combination of AI and combining it with motion graphics and editing. The concept was very well able to convey the key message to all the stakeholders in the fastest time possible in a very easily understandable way."
        }
      ]
    },
    {
      "title": "Halla",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/halla.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "As a passionate animator, I always wanted to build my own concepts and proprietary series which would be entertaining as well as educating people."
        },
        {
          "label": "What I Did",
          "text": "This is my attempt to build end-to-end high-quality animation videos with a combination of natural human creativity visualization and then boost it with an AI-based storyboard production pipeline and AI-based animations. I then put it together with offline tools to make sure everything seamlessly blends in."
        },
        {
          "label": "Impact",
          "text": "The key impact is bringing down the conventional process of consuming a lot of time, effort, and budget to create one such animation series, which is now brought down drastically. Usually a detailed animation like this would take a month's time and a huge team but this was now possible to create in a span of two days. I see this has an opportunity to democratize the way content creation was done and now it is possible to mass produce quality content, create better quality education, create better affordable education, as well as create more entertaining content."
        }
      ]
    },
    {
      "title": "Sajotech",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/sajotech.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Complex services are difficult to explain, especially to those who have less time."
        },
        {
          "label": "What I Did",
          "text": "Video explains how this company is specialized in conducting tests for the structural assessments of bridges. If this was built using cameras, drones, and real people, it would be a really high budget and more time-consuming process. An AI-enabled production pipeline made sure that the same could be done in a more optimized time duration, budget, and high-quality output."
        },
        {
          "label": "Impact",
          "text": "A very highly appreciated video by the stakeholders and the sales team of the company was able to use this to convert projects much more easily and effectively."
        }
      ]
    },
    {
      "title": "Bodhi life",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/bodhi-1.mp4"
        },
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/bodhi-2.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Video ad creation has always been in need but getting a professional output in the fastest time possible has always been challenging."
        },
        {
          "label": "What I Did",
          "text": "I used seedence and Google Omni to create these video ads. It looks easy with the help of AI tools, but engineering the prompting process and getting the consistency was the main outcome."
        },
        {
          "label": "Impact",
          "text": "This opened up a completely new set of doors and thought process for visualizing and storytelling short-form content and building great ads in as little as one day's time, which otherwise would have taken at least 10x the time and resources, as well as the cost."
        }
      ]
    },
    {
      "title": "Bed sheet ad",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/bedsheet.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Product shoots have always been challenging but now, with the help of AI, things have revolutionized the way we visualize and create content. This project shows how we can build cinematic product ads."
        },
        {
          "label": "What I Did",
          "text": "Right from concept, content, camera angles, storyboarding, to getting the final output, the AI pipeline was used and yes, manual intervention is definitely needed for creative conceptualization and final editing."
        },
        {
          "label": "Impact",
          "text": "The brand was able to save up to as much as one-fifth of the costs and time to as little as one-tenth."
        }
      ]
    },
    {
      "title": "Icegen",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/icegen.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Tech companies usually find it difficult to tell about their stories, or it has been an expensive affair."
        },
        {
          "label": "What I Did",
          "text": "I have used my prior experience of building explainer videos from scratch with the help of Adobe tools. Those were great but again the challenge was to do everything manually. Now with the integration I am able to visualize the same kind of an output but at an extremely fast pace. Most importantly the change was always challenging as any change I make with Adobe After Effects would increase the render time a lot. Now with AI even the change management has become simpler, faster, and delivery has become smoother."
        },
        {
          "label": "Impact",
          "text": "Impact has been that one such video was which previously done, one for a company's lifetime or one in a year. Now it can be done in a way that a brand can release even one video per week and tell more stories and enable more growth."
        }
      ]
    },
    {
      "title": "E-learning with AI avatar",
      "outputs": [
        {
          "type": "youtube",
          "src": "https://www.youtube.com/watch?v=ueUziu2rxng"
        },
        {
          "type": "youtube",
          "src": "https://www.youtube.com/watch?v=pTdnPzI2zuI"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Creating E-learning videos was very challenging as a trainer needed to stand in front of the camera, deliver hours of content, make mistakes, reshoot, and then all of that had to be edited by somebody else by watching those contents for hours together. Further once that output comes, even more rounds of changes would ultimately make it a really long and challenging process."
        },
        {
          "label": "What I Did",
          "text": "Using AI avatars, I was able to custom create my own avatar and directly start producing content without having to stand in front of the camera or over and over edit again. I replicated my own self, I replicated my voice, and directly started giving the content that it has to speak, which dramatically increased the quality and brought down the production time."
        },
        {
          "label": "Impact",
          "text": "I always wanted to teach a lot of concepts but it's the time consumption that used to limit my speed. Now I can produce at the speed of my thoughts."
        }
      ]
    },
    {
      "title": "Adastra Ad",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/adastra.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Service-based businesses require good storytelling so that they can convey what they really have to offer but the accessibility or affordability to create one such story was always challenging."
        },
        {
          "label": "What I Did",
          "text": "Now with AI things have been democratized, more power to all small and medium businesses too, and everybody can have a fair share of telling what they are capable of doing. I did the same for this brand and helped them stand out by telling them they are exclusive and combining natural creativity, AI production, and manual editing got the exact output that the brand was expecting."
        },
        {
          "label": "Impact",
          "text": "This made the brand get more visibility and set a standard in the global markets that got more attention from the prospective clients. The team got the belief that yes we now can also position ourselves at a much higher standard."
        }
      ]
    },
    {
      "title": "Cinematic videos",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/cinematic-1.mp4"
        },
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/cinematic-2.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Cinematic videos required a high professional camera set up, a large team, complex editing."
        },
        {
          "label": "What I Did",
          "text": "Using the advanced video models, I was able to produce the same in a fraction of the cost and time and now it's possible to create a full feature film. I believe the change management or trying out newer things is possible so combining storytelling, AI production with the power of being able to experiment with different shots and getting the satisfactory output was the key observation here."
        },
        {
          "label": "Impact",
          "text": "This gave the key stakeholder and myself the power of being able to produce highly cinematic video content and the possibility of scaling it up further."
        }
      ]
    },
    {
      "title": "Explainer animations",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/explainer-1.mp4"
        },
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/explainer-2.mp4"
        },
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/explainer-3.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Explain that our videos are the heart of the marketing and e-learning industry. Though they are extremely powerful, the production time and cost have always been challenging."
        },
        {
          "label": "What I Did",
          "text": "Using beyond AI, I was able to speed up the content creation process and especially character animation. When two characters have to speak to each other, it was always a manual and time-consuming process. Now the same can be leveraged in order to enhance the storytelling process and when two characters speak, the engagement increases and retention multiplies. That's what was achieved in this project. This is a great approach to combine manual and AI and get a fully editable project so that it can be reused again in the future."
        },
        {
          "label": "Impact",
          "text": "Impact is that now e-learning could be enhanced with more animated content, which significantly impacts the learner experience, retains the learners for a longer time, and ultimately improves their learning outcome."
        }
      ]
    },
    {
      "title": "VRL transformers concept",
      "outputs": [
        {
          "type": "video",
          "src": "/portfolio-design/assets/ai-videos/vrl.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Hollywood-style videos have always been out of reach for the normal public, requiring a really high technical team and extremely high costs."
        },
        {
          "label": "What I Did",
          "text": "With the right prompt engineering now it's possible to using AI and get cinematic high-quality Hollywood-style videos. I was able to do that by combining sketches, reference images, video generation models, and a manual editing process."
        },
        {
          "label": "Impact",
          "text": "This became the beginning of a new age fast-paced viral content creation machine and now I'm able to work on limitless creativity and not get limited by the technical or resource limitations."
        }
      ]
    }
  ],
  "Applications": [
    {
      "title": "Dial50",
      "outputs": [
        {
          "type": "link",
          "src": "https://dial50.ai",
          "label": "Visit live application →",
          "preview": "/portfolio-design/assets/site-previews/dial50.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "Building an AI-powered healthcare application from scratch is a complex challenge. The product needed to handle real-time patient routing, AI avatar assistance, and SLA tracking while maintaining a futuristic yet professional interface that would appeal to hospital administrators and healthcare decision-makers."
        },
        {
          "label": "What I Did",
          "text": "I designed and developed the complete web application interface for Dial50.ai, building the end-to-end UI with a futuristic command-system aesthetic. AI tools were used to rapidly prototype interface concepts, generate consistent design elements, and build the interactive components. The website was built to showcase the product's capabilities with animated elements and a tech-forward visual language."
        },
        {
          "label": "Impact",
          "text": "The application website effectively communicates the product's value proposition to healthcare stakeholders. The futuristic design language sets Dial50 apart from conventional healthcare software, and the interactive demo-style presentation has helped the team in their sales conversations and investor pitches."
        }
      ]
    },
    {
      "title": "Al Taj Foods",
      "outputs": [
        {
          "type": "link",
          "src": "https://altajfoods.com/",
          "label": "Visit live application →",
          "preview": "/portfolio-design/assets/site-previews/altaj.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A well-established restaurant group in Hubballi needed a modern food ordering application that could handle their full menu of North Indian and Chinese cuisine, support online ordering, and provide a seamless user experience for their 10,000+ customer base."
        },
        {
          "label": "What I Did",
          "text": "I built the complete web application for Al Taj Foods with integrated online ordering, cart functionality, and user sign-in. AI was used to structure the menu layout, optimize the user flow from browsing to checkout, and generate consistent visual elements that match the brand's traditional yet modern identity. The app was designed to work seamlessly across devices."
        },
        {
          "label": "Impact",
          "text": "The application has streamlined the restaurant's online ordering process significantly. Customers can now browse the full menu, place orders, and track them digitally, reducing phone-based order errors and wait times. The owners reported a noticeable increase in online orders after the app went live."
        }
      ]
    }
  ],
  "Websites": [
    {
      "title": "Marching reels productions",
      "outputs": [
        {
          "type": "link",
          "src": "https://www.marchingreelsproductions.com/",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/marchingreels.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A film production company needed a website that could capture the cinematic grandeur of their work while being modern and visually immersive. The challenge was to build a site that feels like a movie experience itself, reflecting their tagline of being a vision for tomorrow's cinema."
        },
        {
          "label": "What I Did",
          "text": "I designed and built the entire website with a film-reel inspired aesthetic, incorporating cinematic elements like frame counters, real-time timestamps, and coordinate overlays. AI was used to conceptualize the visual direction, generate copy that matches the cinematic tone, and rapidly iterate on the layout to achieve the immersive storytelling feel the brand demanded."
        },
        {
          "label": "Impact",
          "text": "The website stands out as a unique portfolio piece in the film production space. The immersive design language has helped the production house make a strong first impression with potential collaborators and clients, effectively communicating their creative vision before any conversation even begins."
        }
      ]
    },
    {
      "title": "Betta Choc",
      "outputs": [
        {
          "type": "link",
          "src": "https://bettachoc.com",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/bettachoc.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A UK-based sustainable food brand needed a website that would reflect their premium, eco-conscious identity. The site had to be elegant, minimal, and appealing to a health-conscious audience while showcasing their product range in an aspirational way."
        },
        {
          "label": "What I Did",
          "text": "I designed and developed the complete website for Betta Choc, building a dark, premium aesthetic that highlights the product photography. AI tools were used to generate copy, refine the visual layout, and ensure the brand story of sustainability and quality came through in every section of the site."
        },
        {
          "label": "Impact",
          "text": "The website effectively positions Betta Choc as a premium sustainable brand in the UK market. The owners were very happy with how the digital presence matched their brand vision and reported positive feedback from early customers who discovered them through the website."
        }
      ]
    },
    {
      "title": "Dial50",
      "outputs": [
        {
          "type": "link",
          "src": "https://dial50.ai",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/dial50.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "An AI healthcare startup needed a website that could communicate a complex product — an AI patient concierge system — in a way that resonates with hospital administrators and healthcare decision-makers. The challenge was to make a technical product feel accessible yet futuristic."
        },
        {
          "label": "What I Did",
          "text": "I built the complete website with a command-system inspired dark UI, using animated status indicators, diagnostic-style sections, and interactive elements that mirror the product's real-time capabilities. AI was used extensively for copywriting, layout ideation, and building the visual language that bridges healthcare professionalism with tech-forward aesthetics."
        },
        {
          "label": "Impact",
          "text": "The website has become a key sales tool for Dial50, effectively explaining the product's value proposition to potential hospital clients. The unique design language differentiates them from competitors and has contributed to successful demo requests and investor conversations."
        }
      ]
    },
    {
      "title": "Adastra Consultants",
      "outputs": [
        {
          "type": "link",
          "src": "https://roshdemo.site/",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/adastra.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "India's largest women-owned recruitment solutions firm operating across 50+ countries needed a website that reflects their global scale, professional credibility, and premium positioning in executive search and RPO services. The site needed to serve both talent seekers and hiring organizations."
        },
        {
          "label": "What I Did",
          "text": "I designed and developed the complete website with a sophisticated dark aesthetic and particle-effect animations that convey global reach and modern professionalism. AI tools were used to structure the information architecture across multiple service lines, generate compelling copy for each solution area, and build an engaging visual experience with smooth transitions and interactive elements."
        },
        {
          "label": "Impact",
          "text": "The website has elevated Ad Astra's digital presence to match their global operations. It effectively serves as a dual-purpose platform for talent acquisition and client engagement, and the professional design has strengthened their positioning as a premium recruitment partner across international markets."
        }
      ]
    },
    {
      "title": "Amrut Group",
      "outputs": [
        {
          "type": "link",
          "src": "https://amrutgroup.co.in",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/amrut.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A family-run business group in Karwar with nearly 50 years of legacy — spanning a premium hotel, a 500-seater seafood restaurant featured on History Channel and NDTV, a bakery, an inn, and a jewellery store — needed a unified digital presence that honours their heritage while appealing to modern travellers and customers."
        },
        {
          "label": "What I Did",
          "text": "I designed and built a clean, elegant website that brings all of Amrut Group's businesses under one cohesive brand umbrella. AI tools were used to craft the storytelling narrative, structure the experiences section for each business unit, and generate a refined visual design with a warm, trust-evoking colour palette that matches their family-business identity."
        },
        {
          "label": "Impact",
          "text": "The website has given the Amrut Group a unified brand presence for the first time, making it easy for visitors to Karwar to discover all their offerings in one place. The elegant design has helped attract a new segment of digitally-aware travellers and customers who find them through online search."
        }
      ]
    },
    {
      "title": "BMIPS",
      "outputs": [
        {
          "type": "link",
          "src": "https://www.bmips.in/",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/bmips.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A CBSE-affiliated international school in Haveri needed a modern, vibrant website that could effectively communicate their educational philosophy of shaping confident minds, showcase campus life, and drive admissions. The site needed to appeal to parents while reflecting the school's progressive approach to education."
        },
        {
          "label": "What I Did",
          "text": "I designed and developed the complete school website with a vibrant, gradient-rich visual language that feels energetic and youthful. AI tools were used to structure the content across campus life, admissions, community, and careers sections, generate engaging copy, and build interactive elements like the WhatsApp integration for instant parent inquiries. The design balances professionalism with approachability."
        },
        {
          "label": "Impact",
          "text": "The website has become a strong tool for the school's admissions process, with 400+ happy parents engaging through the platform. The modern design sets BMIPS apart from other schools in the region and has helped increase admission inquiries through the integrated WhatsApp and contact channels."
        }
      ]
    }
  ],
  "Branding": [
    {
      "title": "Betta Choc",
      "outputs": [
        {
          "type": "gallery",
          "src": [
            "/portfolio-design/assets/branding/betta/bettachoc3.webp",
            "/portfolio-design/assets/branding/betta/betta-choc-products.webp",
            "/portfolio-design/assets/branding/betta/low-res-product1.webp",
            "/portfolio-design/assets/branding/betta/low-res-powder1.webp",
            "/portfolio-design/assets/branding/betta/low-res-powder2.webp"
          ]
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A new UK-based sustainable chocolate brand needed a complete brand identity built from scratch — logo, colour palette, typography, packaging design, and brand guidelines — that would communicate their values of sustainability, quality, and premium positioning in a competitive market."
        },
        {
          "label": "What I Did",
          "text": "I developed the complete brand identity for Betta Choc from concept to execution. Starting with mood boards and sketched concepts, I used AI to explore multiple visual directions, refine the logo design, and build a cohesive brand guide covering typography, colour systems, and usage rules. The branding was designed to work across packaging, digital, and print touchpoints."
        },
        {
          "label": "Impact",
          "text": "The brand identity was very well received by the founders, who felt it perfectly captured their vision of a premium yet approachable sustainable brand. The cohesive branding system has allowed them to maintain consistency across all customer touchpoints as they scale their market presence."
        }
      ]
    },
    {
      "title": "Dial50",
      "outputs": [
        {
          "type": "gallery",
          "src": [
            "/portfolio-design/assets/branding/dial50/dial50.webp",
            "/portfolio-design/assets/branding/dial50/df1.webp",
            "/portfolio-design/assets/branding/dial50/df2.webp",
            "/portfolio-design/assets/branding/dial50/dial50-booth.webp",
            "/portfolio-design/assets/branding/dial50/dial50-booth1.webp",
            "/portfolio-design/assets/branding/dial50/mockup-stall.webp"
          ]
        },
        {
          "type": "video",
          "src": "/portfolio-design/assets/branding/dial50-brand.mp4"
        },
        {
          "type": "video",
          "src": "/portfolio-design/assets/branding/dial50-expo.mp4"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A healthcare AI startup needed a brand identity that would convey trust, technological sophistication, and innovation. The branding had to work across a product interface, website, pitch decks, and marketing materials while standing out in the crowded health-tech space."
        },
        {
          "label": "What I Did",
          "text": "I created the complete brand identity for Dial50, including logo design, a tech-forward colour system with deep navy and cyan accents, typography selection, and comprehensive brand guidelines. AI tools were used to rapidly iterate on logo concepts, test colour combinations for accessibility and impact, and generate brand collateral templates for presentations and marketing use."
        },
        {
          "label": "Impact",
          "text": "The branding has given Dial50 a strong, recognizable identity in the healthcare AI space. The consistent visual language across their website, product, and pitch materials has strengthened their credibility with hospital clients and investors, contributing to a professional and trustworthy brand perception."
        }
      ]
    }
  ]
};

export const WA_CASE_GROUPS = {
  "UI/UX": [
    {
      "title": "Trusgo",
      "outputs": [
        {
          "type": "link",
          "src": "https://xd.adobe.com/view/3bc9faf0-a799-4539-8404-ca6bad554dc6-6e9a/",
          "label": "View prototype →",
          "preview": "/portfolio-design/assets/site-previews/trusgo.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A transportation startup needed a comprehensive and user-friendly mobile app design for booking train tickets across India, covering the entire user journey from search to booking confirmation."
        },
        {
          "label": "What I Did",
          "text": "I designed the complete UI for the mobile app in Adobe XD, creating 49 screens that cover the full user flow — from onboarding and login to train search, seat selection, booking management, and customer support. The design features a clean, intuitive interface with a consistent visual language throughout."
        },
        {
          "label": "Impact",
          "text": "The prototype provided a complete, interactive blueprint that clearly mapped out the entire user experience, giving the development team a solid foundation to build the app from."
        }
      ]
    },
    {
      "title": "Optotap",
      "outputs": [
        {
          "type": "link",
          "src": "https://www.canva.com/design/DAFET41qVdM/eC73lj9oL0gC3VYDliVLeQ/view",
          "label": "View prototype →",
          "preview": "/portfolio-design/assets/site-previews/optotap.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A business services platform needed a mobile app design that would make it simple for small businesses to set up their online stores, manage deliveries, and handle subscriptions all in one place."
        },
        {
          "label": "What I Did",
          "text": "I designed the UI for the mobile app in Canva, creating 16 screens that walk users through the complete onboarding and store setup process — from registration and OTP verification to business details, location selection, and subscription management. The design uses a warm, approachable visual style with gold accent buttons and clear step-by-step flows."
        },
        {
          "label": "Impact",
          "text": "The design gave OptoTap a polished, user-friendly interface that simplifies the process of getting small businesses online, making the platform accessible even to non-technical store owners."
        }
      ]
    }
  ],
  "Websites": [
    {
      "title": "Born Maverick",
      "outputs": [
        {
          "type": "link",
          "src": "https://bornmaverick.co.uk",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/bornmaverick.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A biotech food innovation startup needed a professional website that could effectively communicate complex scientific concepts around sustainable food technology while being visually appealing and accessible to investors, partners, and consumers."
        },
        {
          "label": "What I Did",
          "text": "I designed and developed the complete website, focusing on building a clean, modern layout that balances scientific credibility with engaging visual storytelling. The information architecture was carefully structured to guide visitors through the company's mission, their innovative product platforms, and the global food challenges they are addressing."
        },
        {
          "label": "Impact",
          "text": "The website successfully established Born Maverick's digital presence and positioned them as a credible, science-driven food innovation company. It became their primary platform for attracting investors, partners, and customers."
        }
      ]
    },
    {
      "title": "Trip Tales",
      "outputs": [
        {
          "type": "link",
          "src": "https://www.triptales.co/",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/triptales.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A Kenya-based travel company needed a website that would showcase their unique, off-the-beaten-path travel experiences and differentiate them from conventional tourism operators."
        },
        {
          "label": "What I Did",
          "text": "I designed and built the website end to end, creating a clean and inviting layout that highlights the company's unique value proposition of authentic Kenyan travel experiences. The site was structured with clear navigation, compelling calls to action, and a design that captures the spirit of adventure travel."
        },
        {
          "label": "Impact",
          "text": "The website gave Trip Tales a strong digital storefront that effectively communicates their brand story and converts visitors into inquiries. It serves as their primary tool for attracting and engaging potential travelers."
        }
      ]
    },
    {
      "title": "Kokonut Boutique",
      "outputs": [
        {
          "type": "link",
          "src": "http://www.kokonutboutique.com/",
          "label": "Visit live site →",
          "preview": "/portfolio-design/assets/site-previews/kokonut.webp"
        }
      ],
      "sections": [
        {
          "label": "The Challenge / Opportunity",
          "text": "A Mysore-based ethnic fashion brand needed a fully functional e-commerce website to showcase and sell their handcrafted embroidered salwar suit collections online."
        },
        {
          "label": "What I Did",
          "text": "I designed and developed the complete e-commerce website, building out the product catalog, shopping cart, wishlist, and user account functionalities. The design was crafted to reflect the brand's identity of exquisite craftsmanship meeting modern style, with a clean product gallery and an intuitive browsing experience."
        },
        {
          "label": "Impact",
          "text": "The website enabled Kokonut Boutique to take their business online and reach customers beyond their local market. It serves as both a storefront and brand showcase, giving them a professional platform to sell their collections directly to customers."
        }
      ]
    }
  ]
};


export const VISUAL_GRAPHIC_GROUPS = [
  {
    "label": "Digital painting",
    "images": [
      "/portfolio-design/assets/legacy/l76.webp",
      "/portfolio-design/assets/legacy/l81.webp",
      "/portfolio-design/assets/legacy/l82.webp",
      "/portfolio-design/assets/legacy/l83.webp",
      "/portfolio-design/assets/legacy/l84.webp",
      "/portfolio-design/assets/legacy/l85.webp",
      "/portfolio-design/assets/legacy/l86.webp",
      "/portfolio-design/assets/legacy/l87.webp",
      "/portfolio-design/assets/legacy/l88.webp",
      "/portfolio-design/assets/legacy/l77.webp",
      "/portfolio-design/assets/legacy/l78.webp",
      "/portfolio-design/assets/legacy/l79.webp",
      "/portfolio-design/assets/legacy/l80.webp"
    ]
  },
  {
    "label": "3D renders",
    "images": [
      "/portfolio-design/assets/legacy/l9.webp",
      "/portfolio-design/assets/legacy/l14.webp",
      "/portfolio-design/assets/legacy/l15.webp",
      "/portfolio-design/assets/legacy/l16.webp",
      "/portfolio-design/assets/legacy/l17.webp",
      "/portfolio-design/assets/legacy/l18.webp",
      "/portfolio-design/assets/legacy/l19.webp",
      "/portfolio-design/assets/legacy/l20.webp",
      "/portfolio-design/assets/legacy/l21.webp",
      "/portfolio-design/assets/legacy/l10.webp",
      "/portfolio-design/assets/legacy/l11.webp",
      "/portfolio-design/assets/legacy/l12.webp",
      "/portfolio-design/assets/legacy/l13.webp"
    ]
  },
  {
    "label": "Product label",
    "images": [
      "/portfolio-design/assets/legacy/l97.webp",
      "/portfolio-design/assets/legacy/l98.webp",
      "/portfolio-design/assets/legacy/l99.webp",
      "/portfolio-design/assets/legacy/l100.webp",
      "/portfolio-design/assets/legacy/l101.webp",
      "/portfolio-design/assets/legacy/l102.webp",
      "/portfolio-design/assets/legacy/l103.webp",
      "/portfolio-design/assets/legacy/l104.webp",
      "/portfolio-design/assets/legacy/l105.webp"
    ]
  },
  {
    "label": "Product Package",
    "images": [
      "/portfolio-design/assets/legacy/l106.webp",
      "/portfolio-design/assets/legacy/l107.webp",
      "/portfolio-design/assets/legacy/l108.webp",
      "/portfolio-design/assets/legacy/l109.webp",
      "/portfolio-design/assets/legacy/l110.webp",
      "/portfolio-design/assets/legacy/l111.webp",
      "/portfolio-design/assets/legacy/l112.webp",
      "/portfolio-design/assets/legacy/l113.webp",
      "/portfolio-design/assets/legacy/l114.webp"
    ]
  },
  {
    "label": "Character design",
    "images": [
      "/portfolio-design/assets/legacy/l63.webp",
      "/portfolio-design/assets/legacy/l68.webp",
      "/portfolio-design/assets/legacy/l69.webp",
      "/portfolio-design/assets/legacy/l70.webp",
      "/portfolio-design/assets/legacy/l71.webp",
      "/portfolio-design/assets/legacy/l72.webp",
      "/portfolio-design/assets/legacy/l73.webp",
      "/portfolio-design/assets/legacy/l74.webp",
      "/portfolio-design/assets/legacy/l75.webp",
      "/portfolio-design/assets/legacy/l64.webp",
      "/portfolio-design/assets/legacy/l65.webp",
      "/portfolio-design/assets/legacy/l66.webp",
      "/portfolio-design/assets/legacy/l67.webp"
    ]
  },
  {
    "label": "Infographics",
    "images": [
      "/portfolio-design/assets/legacy/l89.webp",
      "/portfolio-design/assets/legacy/l90.webp",
      "/portfolio-design/assets/legacy/l91.webp",
      "/portfolio-design/assets/legacy/l92.webp",
      "/portfolio-design/assets/legacy/l93.webp",
      "/portfolio-design/assets/legacy/l94.webp",
      "/portfolio-design/assets/legacy/l95.webp",
      "/portfolio-design/assets/legacy/l96.webp"
    ]
  },
  {
    "label": "Poster / Flyer",
    "images": [
      "/portfolio-design/assets/legacy/l151.webp",
      "/portfolio-design/assets/legacy/l152.webp",
      "/portfolio-design/assets/legacy/l153.webp",
      "/portfolio-design/assets/legacy/l154.webp",
      "/portfolio-design/assets/legacy/l155.webp",
      "/portfolio-design/assets/legacy/l156.webp",
      "/portfolio-design/assets/legacy/l157.webp",
      "/portfolio-design/assets/legacy/l158.webp"
    ]
  },
  {
    "label": "Sketch illustrations",
    "images": [
      "/portfolio-design/assets/legacy/l115.webp",
      "/portfolio-design/assets/legacy/l116.webp",
      "/portfolio-design/assets/legacy/l117.webp",
      "/portfolio-design/assets/legacy/l118.webp",
      "/portfolio-design/assets/legacy/l119.webp",
      "/portfolio-design/assets/legacy/l120.webp",
      "/portfolio-design/assets/legacy/l121.webp",
      "/portfolio-design/assets/legacy/l122.webp",
      "/portfolio-design/assets/legacy/l123.webp"
    ]
  },
  {
    "label": "AI Art",
    "images": [
      "/portfolio-design/assets/legacy/l22.webp",
      "/portfolio-design/assets/legacy/l29.webp",
      "/portfolio-design/assets/legacy/l30.webp",
      "/portfolio-design/assets/legacy/l31.webp",
      "/portfolio-design/assets/legacy/l32.webp",
      "/portfolio-design/assets/legacy/l33.webp",
      "/portfolio-design/assets/legacy/l34.webp",
      "/portfolio-design/assets/legacy/l35.webp",
      "/portfolio-design/assets/legacy/l36.webp",
      "/portfolio-design/assets/legacy/l23.webp",
      "/portfolio-design/assets/legacy/l24.webp",
      "/portfolio-design/assets/legacy/l25.webp",
      "/portfolio-design/assets/legacy/l26.webp",
      "/portfolio-design/assets/legacy/l27.webp",
      "/portfolio-design/assets/legacy/l28.webp"
    ]
  },
  {
    "label": "Cartoons",
    "images": [
      "/portfolio-design/assets/legacy/l50.webp",
      "/portfolio-design/assets/legacy/l55.webp",
      "/portfolio-design/assets/legacy/l56.webp",
      "/portfolio-design/assets/legacy/l57.webp",
      "/portfolio-design/assets/legacy/l58.webp",
      "/portfolio-design/assets/legacy/l59.webp",
      "/portfolio-design/assets/legacy/l60.webp",
      "/portfolio-design/assets/legacy/l61.webp",
      "/portfolio-design/assets/legacy/l62.webp",
      "/portfolio-design/assets/legacy/l51.webp",
      "/portfolio-design/assets/legacy/l52.webp",
      "/portfolio-design/assets/legacy/l53.webp",
      "/portfolio-design/assets/legacy/l54.webp"
    ]
  },
  {
    "label": "Caricature",
    "images": [
      "/portfolio-design/assets/legacy/l42.webp",
      "/portfolio-design/assets/legacy/l43.webp",
      "/portfolio-design/assets/legacy/l44.webp",
      "/portfolio-design/assets/legacy/l45.webp",
      "/portfolio-design/assets/legacy/l46.webp",
      "/portfolio-design/assets/legacy/l47.webp",
      "/portfolio-design/assets/legacy/l48.webp",
      "/portfolio-design/assets/legacy/l49.webp"
    ]
  },
  {
    "label": "Social media posts",
    "images": [
      "/portfolio-design/assets/legacy/l124.webp",
      "/portfolio-design/assets/legacy/l125.webp",
      "/portfolio-design/assets/legacy/l126.webp",
      "/portfolio-design/assets/legacy/l127.webp",
      "/portfolio-design/assets/legacy/l128.webp",
      "/portfolio-design/assets/legacy/l129.webp",
      "/portfolio-design/assets/legacy/l130.webp"
    ]
  },
  {
    "label": "Logo design",
    "images": [
      "/portfolio-design/assets/legacy/l143.webp",
      "/portfolio-design/assets/legacy/l144.webp",
      "/portfolio-design/assets/legacy/l145.webp",
      "/portfolio-design/assets/legacy/l_logo4.webp",
      "/portfolio-design/assets/legacy/l147.webp",
      "/portfolio-design/assets/legacy/l148.webp",
      "/portfolio-design/assets/legacy/l149.webp",
      "/portfolio-design/assets/legacy/l150.webp"
    ]
  },
  {
    "label": "Banner",
    "images": [
      "/portfolio-design/assets/legacy/l37.webp",
      "/portfolio-design/assets/legacy/l38.webp",
      "/portfolio-design/assets/legacy/l39.webp",
      "/portfolio-design/assets/legacy/l40.webp",
      "/portfolio-design/assets/legacy/l41.webp"
    ]
  },
  {
    "label": "Standee",
    "images": [
      "/portfolio-design/assets/legacy/l131.webp",
      "/portfolio-design/assets/legacy/l132.webp",
      "/portfolio-design/assets/legacy/l133.webp",
      "/portfolio-design/assets/legacy/l134.webp",
      "/portfolio-design/assets/legacy/l135.webp"
    ]
  },
  {
    "label": "Business Card",
    "images": [
      null,
      null,
      null,
      null
    ]
  },
  {
    "label": "Letter head",
    "images": [
      "/portfolio-design/assets/legacy/l139.webp",
      "/portfolio-design/assets/legacy/l140.webp",
      "/portfolio-design/assets/legacy/l141.webp",
      "/portfolio-design/assets/legacy/l142.webp"
    ]
  },
  {
    "label": "Menu design",
    "images": [
      null,
      null,
      null,
      null
    ]
  },
  {
    "label": "Kiosk design",
    "images": [
      "/portfolio-design/assets/legacy/l136.webp",
      "/portfolio-design/assets/legacy/l137.webp",
      "/portfolio-design/assets/legacy/l138.webp"
    ]
  }
];

export const ANIMATION_GROUPS = [
  {
    "label": "E-learning videos",
    "videos": [
      "https://www.youtube.com/embed/QHoTP-Prue8",
      "https://www.youtube.com/embed/6AedQs8XA_c",
      "https://www.youtube.com/embed/LYmLfZ9bpjo",
      "https://www.youtube.com/embed/CcrsspqOfKw",
      "https://www.youtube.com/embed/JxqtAlggR84",
      "https://www.youtube.com/embed/uF9kHhvx7gU",
      "https://www.youtube.com/embed/ICndcs91Yzw",
      "https://www.youtube.com/embed/_pKoLJjtfpc"
    ]
  },
  {
    "label": "Explainer videos",
    "videos": [
      "https://www.youtube.com/embed/XljNF8AIZBQ",
      "https://www.youtube.com/embed/a2CdfbTk2JI",
      "https://www.youtube.com/embed/2i_tfgtKx5Q",
      "https://www.youtube.com/embed/lWZxo3elOyM",
      "https://www.youtube.com/embed/CuKvUxUWIU0",
      "https://www.youtube.com/embed/Fy2GtqJybok",
      "https://www.youtube.com/embed/vWKLYLfoqtc",
      "https://www.youtube.com/embed/Jn4el1MwP3w",
      "https://www.youtube.com/embed/TOCfyIIZ3wo",
      "https://www.youtube.com/embed/rbW8M7gTOC4",
      "https://www.youtube.com/embed/ciNQL0KQz1I",
      "https://www.youtube.com/embed/AGiIA_El2Ho",
      "https://www.youtube.com/embed/kltkcTJu4no",
      "https://www.youtube.com/embed/1OTAD9ufxKE",
      "https://www.youtube.com/embed/GaJTk7pWVmQ",
      "https://www.youtube.com/embed/oFOX4Oxw--M",
      "https://www.youtube.com/embed/4YSQKYo0AEc"
    ]
  },
  {
    "label": "3D walkthroughs",
    "videos": [
      "https://www.youtube.com/embed/UJ4cND-pnM4",
      "https://www.youtube.com/embed/wr2XyPtmo2M",
      "https://www.youtube.com/embed/vJWwLAdqB7o",
      "https://www.youtube.com/embed/vWKLYLfoqtc",
      "https://www.youtube.com/embed/vWKLYLfoqtc",
      "https://www.youtube.com/embed/997U44jHW14",
      "https://www.youtube.com/embed/_5Ug5X-tADI",
      "https://www.youtube.com/embed/S4DfX7hHrfA"
    ]
  },
  {
    "label": "Motion graphics",
    "videos": [
      "https://www.youtube.com/embed/8KYHKdR0hvQ",
      "https://www.youtube.com/embed/znWFRybQn2U",
      "https://www.youtube.com/embed/Ls2WLFsJhdw",
      "https://www.youtube.com/embed/vdkE_g3pUf8",
      "https://www.youtube.com/embed/ba-FjRLfrds",
      "https://www.youtube.com/embed/3WCVMwoDhHU"
    ]
  },
  {
    "label": "Cartoon animation",
    "videos": [
      "https://www.youtube.com/embed/f-EgytnnIlM",
      "https://www.youtube.com/embed/a2CdfbTk2JI",
      "https://www.youtube.com/embed/rbW8M7gTOC4",
      "https://www.youtube.com/embed/ciNQL0KQz1I",
      "https://www.youtube.com/embed/ELM5uj8heA0"
    ]
  },
  {
    "label": "White board animation",
    "videos": [
      "https://www.youtube.com/embed/4YSQKYo0AEc",
      "https://www.youtube.com/embed/fX2q_gdE29k",
      "https://www.youtube.com/embed/5zEMtV3v0Pc",
      "https://www.youtube.com/embed/yC0KEB3seUo",
      "https://www.youtube.com/embed/LlRxDoLWvrU",
      "https://www.youtube.com/embed/X9lNJ5XZDa0"
    ]
  },
  {
    "label": "AI videos",
    "videos": [
      "https://www.youtube.com/embed/24F3qXBHdpw",
      "https://www.youtube.com/embed/ueUziu2rxng",
      "https://www.youtube.com/embed/pTdnPzI2zuI",
      "https://www.youtube.com/embed/pdwY2CbutJ0",
      "https://www.youtube.com/embed/_pKoLJjtfpc"
    ]
  },
  {
    "label": "Logo animation",
    "videos": [
      "https://www.youtube.com/embed/i8yhV0uxhQY",
      "https://www.youtube.com/embed/gmx21-3NmWs",
      "https://www.youtube.com/embed/nomwLWjBXLY",
      "https://www.youtube.com/embed/pZj5FQJvCVY"
    ]
  },
  {
    "label": "Social media videos",
    "videos": [
      "https://www.youtube.com/embed/vdkE_g3pUf8",
      "https://www.youtube.com/embed/eLQnk9jjDww",
      "https://www.youtube.com/embed/v4uXFASP-4Q",
      "https://www.youtube.com/embed/JjNAepjMDz4",
      "https://www.youtube.com/embed/Ku52owSB3oc"
    ]
  },
  {
    "label": "Training videos",
    "videos": [
      "https://www.youtube.com/embed/q-WFSrzK3H8",
      "https://www.youtube.com/embed/ueUziu2rxng",
      "https://www.youtube.com/embed/pTdnPzI2zuI",
      "https://www.youtube.com/embed/6AedQs8XA_c",
      "https://www.youtube.com/embed/6j0erfO07kw",
      "https://www.youtube.com/embed/AeFk9GrMTGM",
      "https://www.youtube.com/embed/pdwY2CbutJ0",
      "https://www.youtube.com/embed/qk-DYYmde2Q"
    ]
  }
];

export const HANDMADE_IMAGES = [
  "/portfolio-design/assets/legacy/l159.webp",
  "/portfolio-design/assets/legacy/l160.webp",
  "/portfolio-design/assets/legacy/l161.webp",
  "/portfolio-design/assets/legacy/l0.webp",
  "/portfolio-design/assets/legacy/l1.webp",
  "/portfolio-design/assets/legacy/l2.webp",
  "/portfolio-design/assets/legacy/l3.webp",
  "/portfolio-design/assets/legacy/l4.webp",
  "/portfolio-design/assets/legacy/l5.webp",
  "/portfolio-design/assets/legacy/l6.webp",
  "/portfolio-design/assets/legacy/l7.webp",
  "/portfolio-design/assets/legacy/l8.webp"
];

export const GLIMPSES = {
  videos: ["Hxwxg1bqRbA", "9tEl0vm4chg", "b_NzKJGraic", "ky7LONmL_XE"].map(
    (id) => `https://www.youtube.com/embed/${id}`
  ),
  uniqueAttempt: {
    title: "An Unique Attempt",
    paragraphs: [
      "On 22 Feb 2022 (22-02-2022 / 22022022), I made an unique attempt. It was an unique date 22022022 (palindrome & an ambigram). I went live on YouTube for 22 hours to create digital art on live stream, started at 2.22 am. The attempt was successful & I created 100 artworks during the live stream.",
      "Here's a glimpse of it, watch the video:",
    ],
    video: "https://www.youtube.com/embed/DQNN23b5k_A",
  },
};
